export const SKIP_IDS = [
  'a7ce06f5-634f-4159-8670-719eb36845b4',
  'f6952634-4d43-41ca-a374-80e5b881493b',
];
